import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-100 text-gray-600 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img src="/logo-icon.svg" alt="Supervisor" className="w-10 h-10" />
              <span className="text-xl font-bold text-gray-900">Supervisor</span>
            </Link>
            <p className="text-gray-500 max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">{t('footer.product')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/features" className="hover:text-[#7876bb] transition-colors">
                  {t('nav.features')}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-[#7876bb] transition-colors">
                  {t('nav.pricing')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-[#7876bb] transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#7876bb] transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            {t('footer.copyright')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-[#7876bb]">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-[#7876bb]">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;